import React from 'react';
import { Container, Typography, Box, Paper, Link, Divider } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';

export default function ContactPage() {
    return (
        <Container maxWidth="sm" sx={{ py: 6 }}>
            <Typography variant="h4" fontWeight={700} gutterBottom>
                Contact
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={4}>
                Have a question, want to report an issue, or interested in integration? Get in touch.
            </Typography>

            <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
                <Typography variant="overline" color="text.disabled" fontWeight={700} letterSpacing={1.2}>
                    Email
                </Typography>
                <Divider sx={{ my: 1.5 }} />
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <EmailIcon color="action" />
                    <Link
                        href="mailto:sovavoice@networkninjas.cz"
                        underline="hover"
                        sx={{ fontSize: '1rem' }}
                    >
                        sovavoice@networkninjas.cz
                    </Link>
                </Box>
            </Paper>
        </Container>
    );
}
